var map = {
	"./1.jpg": 360,
	"./2.jpg": 361,
	"./3.jpg": 362,
	"./4.jpg": 363,
	"./4.png": 364,
	"./Cantones-13.png": 365,
	"./Distrito-01.png": 106,
	"./Distrito-02.png": 109,
	"./Distrito-03.png": 108,
	"./Distrito-04.png": 107,
	"./Distrito-05.png": 113,
	"./Distrito-06.png": 111,
	"./Distrito-07.png": 112,
	"./Distrito-08.png": 110,
	"./Distrito-09.png": 115,
	"./Distrito-10.png": 116,
	"./Distrito-11.png": 114,
	"./Distrito-12.png": 117,
	"./PZ.png": 366,
	"./escudos/baru.jpeg": 141,
	"./escudos/cajon.jpeg": 142,
	"./escudos/danielflores.jpeg": 143,
	"./escudos/general.jpeg": 144,
	"./escudos/laamistad.jpeg": 145,
	"./escudos/paramo.jpeg": 146,
	"./escudos/pejibaye.jpeg": 147,
	"./escudos/platanares.jpeg": 148,
	"./escudos/rionuevo.jpeg": 149,
	"./escudos/rivas.jpeg": 150,
	"./escudos/sanisidro.jpeg": 151,
	"./escudos/sanpedro.jpeg": 152,
	"./florafauna.jpg": 367,
	"./geografia.png": 368,
	"./geologia.jpg": 369,
	"./pz.jpg": 153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;